var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeaker = function SvgSpeaker(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.243 1.754v.165a.77.77 0 0 0 .494.704 5.795 5.795 0 0 1 3.618 5.379 5.795 5.795 0 0 1-3.618 5.378.76.76 0 0 0-.494.704v.165c0 .521.518.886.995.704A7.43 7.43 0 0 0 15 8.002a7.43 7.43 0 0 0-4.762-6.952c-.477-.19-.995.183-.995.704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.928 5.363Q11.3 6.314 11.3 8c0 1.686-.457 2.003-1.372 2.637a.4.4 0 0 1-.628-.329V5.692a.4.4 0 0 1 .628-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1 6.346v3.31c0 .456.37.828.822.828H3.42l2.705 3.026c.519.521 1.407.146 1.407-.59V3c0-.736-.888-1.031-1.407-.51L3.42 5.519H1.822A.827.827 0 0 0 1 6.346"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeaker);
export default ForwardRef;